<template>
  <div class="router-btn">
    <span class="router-title">排行榜</span>

    <div class="router-list">
      <template v-for="(item, index) in router_list" :key="index">
        <div class="list-item">
          {{ item.text }}门派排行榜 >>
          <div class="router-school">
            <div class="router-school-wrapper">
              <p
                class="list-item"
                v-for="(title, key) in schools"
                :key="key"
                @click="select({ order_key: item.value, school: key })"
              >
                {{ title }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="list-item"
          @click="select({ order_key: item.value, server: props.server })"
        >
          {{ item.text }}服务器排行榜
        </div>
        <div class="list-item" @click="select({ order_key: item.value })">
          {{ item.text }}排行榜
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const { schools, sectors, rank_type } = inject('GlobalStore');

const router = useRouter();

const props = defineProps({
  server: {
    type: String,
    required: true,
  },
});

const router_list = computed(() => {
  return [...rank_type.value].reverse();
});

const select = (params) => {
  console.log('hover', params);
  
  router.push({
    path: `/rank`,
    query: params,
  });
};
</script>

<style lang="scss" scoped postcss="false">

.router {
  &-btn {
    cursor: pointer;
    position: relative;
    &:hover {
      .router-list {
        display: block;
      }
    }
  }

  &-title {
    color: #ff581e;
    font-size: 18px;
  }

  &-list {
    position: absolute;
    top: 20px;
    left: 0;
    width: 160px;
    background-color: rgb(107, 107, 107);
    display: none;
    flex-direction: column;
    z-index: 10;
    .list-item {
      padding: 8px 12px;
      cursor: pointer;
      position: relative;

      &:hover {
        background-color: #ff581e;
        .router-school {
          display: block;
        }
      }
    }
  }

  &-school {
    display: none;
    position: absolute;
    top: 0;
    left: 155px;
    padding-left: 10px;
    width: 120px;
    z-index: 10;
  }
  
  &-school-wrapper {
    background-color: rgb(107, 107, 107);
  }
}
</style>